import { render } from "./DashboardView.vue?vue&type=template&id=18950a72&scoped=true&ts=true"
import script from "./dashboard.ts?vue&type=script&lang=ts"
export * from "./dashboard.ts?vue&type=script&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=18950a72&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18950a72"]])

export default __exports__